import { z } from 'zod'

// Unlike googleAudiences' response (array of rich objects), the existing
// Meta call-to-action endpoint returns a flat array of enum strings (e.g.
// "SHOP_NOW") and CampaignForm.jsx's sortedCtaOptions derivation assumes
// exactly that shape. The migration guide's §6.1 doesn't call out any
// change to the response shape for the Google variant, so this mirrors it.
export const googleCallToActionsResponseSchema = z.array(z.string())
